import { insertSanitizedHtml } from '../../../../utils/word/insert-content'
import { addCommentReplies, insertReviewComments } from '../../../word/word-service'
import type { SkillRunResult } from '../../types'
import {
  parseCommentRepliesArgs,
  parseInsertCommentsArgs,
  parseInsertHtmlArgs,
  wordCommentBatchToSkillContent,
} from './utils'

export const INSERT_COMMENTS_NONE_ANCHORED_ERROR =
  'No comments could be anchored. Re-read paragraph ids from the document; ids may be stale, outside the current selection, or the paragraph was removed.'

export const REPLIES_NONE_ADDED_ERROR =
  'No replies were added. Re-read comment thread ids from get_full_document_comments; threads may have been deleted.'

/**
 * Inserts sanitized HTML at the current selection using the same table/prose routing
 * as the chat Insert action. Enables Word Track Changes for agent inserts.
 */
export async function runInsertHtml(args: Record<string, unknown>): Promise<SkillRunResult> {
  const parsed = parseInsertHtmlArgs(args)
  if (!parsed.ok) {
    return { ok: false, error: parsed.error }
  }

  await insertSanitizedHtml(parsed.html, {
    location: parsed.location,
    trackChanges: true,
  })
  return { ok: true, content: { ok: true } }
}

export async function runInsertComments(args: Record<string, unknown>): Promise<SkillRunResult> {
  const parsed = parseInsertCommentsArgs(args)
  if (!parsed.ok) {
    return { ok: false, error: parsed.error }
  }

  const result = await insertReviewComments(parsed.comments, parsed.options)
  if (result.insertedCount === 0) {
    return { ok: false, error: INSERT_COMMENTS_NONE_ANCHORED_ERROR }
  }

  return { ok: true, content: wordCommentBatchToSkillContent(result) }
}

export async function runAddCommentReplies(args: Record<string, unknown>): Promise<SkillRunResult> {
  const parsed = parseCommentRepliesArgs(args)
  if (!parsed.ok) {
    return { ok: false, error: parsed.error }
  }

  const result = await addCommentReplies(parsed.replies)
  if (result.insertedCount === 0) {
    return { ok: false, error: REPLIES_NONE_ADDED_ERROR }
  }

  return { ok: true, content: wordCommentBatchToSkillContent(result) }
}
